export const ErrorPage = () => {
  return (
    <div className="flex flex-col items-center justify-center h-screen bg-black">
      <img
        src="https://cdn.aippy.ai/image/329d3a39a01e4cc697a5d70d46578b65.svg"
        alt="preview error"
        className="w-[108px]"
      />

      <div className="font-medium mt-8 text-xl text-white">Something Didn’t Go as Planned</div>
      <div className="mt-3 text-sm text-[#D1D1D1]">We ran into an issue during the build. </div>
      <div className="text-sm text-[#D1D1D1]">Make sure everything looks right and try again.</div>
    </div>
  );
};
